import '../scss/customer.scss';
import '../components/form-addresses';
import { showPassword } from '../utils/show-password'
import { $Q } from '../utils/query-selector';

const toggleContainer = (elementShow, elementhidden) => {
  $Q(elementShow).dataset.active = true;
  $Q(elementhidden).dataset.active = false;
};

(function recoverToggle() {
  if (!$Q('#display-recover')) return;

  const url = new URL(window.location.href);

  if (url.hash.includes('#recover')) {
    toggleContainer('#recover-container', '#login-container')
  }

  if (url.hash.includes('#login')) {
    toggleContainer('#login-container', '#recover-container')
  }

  $Q('#display-recover').addEventListener('click',
    () => toggleContainer('#recover-container', '#login-container'),
  );

  $Q('#recover-hidden').addEventListener('click',
    () => {
      $Q(".form__message--error").classList.add('hidden')
      toggleContainer('#login-container', '#recover-container')
    }
  );
}());

showPassword();
